var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.roleName == 'tech')?_c('Technic'):_vm._e(),(_vm.roleName == 'callcenter' || _vm.roleName == 'personel')?_c('Ara'):_vm._e(),(_vm.roleName == 'admin' || _vm.roleName == 'dealer')?_c('Admin'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }